import React from 'react';

const NotFoundScreen: React.FC = () => (
  <>
    <div className="d-flex h-100 text-center align-items-center">
      <h1>404</h1>
      <h2 className="text-muted">Page Not Found</h2>
    </div>
  </>
);

export default NotFoundScreen;
